import type { ComponentProps, ReactNode } from 'react';
import { Button, Card, Icon } from '@humanforce/mango-ui-react';

type MangoIconName = ComponentProps<typeof Icon>['name'];

export interface SectionCardProps {
  title: string;
  subtitle?: string;
  icon: string;
  isEditing?: boolean;
  onEdit?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  children: ReactNode;
}

export const SectionCard = ({ title, subtitle, icon, isEditing = false, onEdit, onSave, onCancel, children }: SectionCardProps) => (
  <Card
    header={
      <div className="mgo-split mgo-align-center">
        <div className="mgo-cluster">
          <span className="mgo-cluster mgo-text-m mgo-radius-strong mgo-padding-s mgo-background-brand" style={{ color: 'var(--mgo-color-fg-brand)' }}>
            <Icon name={icon as MangoIconName} />
          </span>
          <div className="mgo-stack mgo-gap-2xs">
            <div className="mgo-text-m mgo-weight-strong">{title}</div>
            {subtitle && <div className="mgo-text-s mgo-color-muted">{subtitle}</div>}
          </div>
        </div>
        <div className="mgo-cluster mgo-gap-s">
          {isEditing ? (
            <>
              {onCancel && <Button variant="tertiary" onClick={onCancel}>Cancel</Button>}
              {onSave && <Button variant="primary" onClick={onSave}>Save</Button>}
            </>
          ) : (
            onEdit && <Button variant="secondary" onClick={onEdit}>Edit</Button>
          )}
        </div>
      </div>
    }
  >
    {children}
  </Card>
);
